export default {
  title: 'Pikalinkit',
  links: {
    reservations: 'Varaukset',
    orders_portal: 'Terminaalikirjautuminen',
    closed: 'Suljettu?',
    menu: 'Muuta valikkoa',
    payouts: 'Tilitysraportit',
    opening_hours: 'Aukioloajat',
  },
};
